import React, { useEffect, useState } from 'react';
import {
  AssociateButton,
  DeleteModal,
  getTranslatedText,
  toast,
  EventEmitter
} from '@nile/components';
import { Button, ButtonGroup, TextStyle } from '@superops/ui-design-system';
import withErrorBoundary from '@nile/components/src/HOC/withErrorBoundary';
import { SVGIcon } from '@superops/super-icons';
import { useMutation, useLazyQuery } from '@apollo/client';
import {
  AccountClient,
  CONVERT_UNKNOWN_EMAIL_TO_TICKET,
  CONVERT_UNKNOWN_EMAIL_TO_TICKET_NEW,
  DELETE_UNKNOWN_EMAILS,
  GET_TICKET_AUDIT,
  SOFT_TICKET_DELETE
} from '@nile/graphql';
import { useIntl, FormattedMessage } from 'react-intl';

const UnknownTicketActions = ({
  ticket,
  associationSuccess,
  deletionSuccess,
  isClassicView = false
}) => {
  const intl = useIntl();
  const [selectedClient, setSelectedClient] = useState({
    client: null,
    site: null,
    requester: null
  });

  const [GetTicketAudit, { data, loading, error }] = useLazyQuery(
    GET_TICKET_AUDIT,
    {
      fetchPolicy: 'network-only',
      variables: {
        input: {
          ticketId: ticket?.ticketId || null
        }
      }
    }
  );

  const metaData = {
    ...ticket,
    fromAddress:
      ticket?.latestReply?.user?.email ||
      data?.getTicketAudit?.[0]?.user?.email ||
      undefined
  };

  const [
    convertUnknownEmaiklToTicket,
    { loading: convertTicketLoading }
  ] = useMutation(CONVERT_UNKNOWN_EMAIL_TO_TICKET_NEW, {
    onCompleted(res) {}
  });

  // const [deleteUnknownEmails] = useMutation(DELETE_UNKNOWN_EMAILS, {
  //   client: AccountClient
  // });

  const [softDeleteTicket, { loading: softDeleteLoading }] = useMutation(
    SOFT_TICKET_DELETE
  );

  function onSubmit(clientData, callback) {
    convertUnknownEmaiklToTicket({
      variables: {
        input: {
          ...clientData,
          tickets: [{ ticketId: ticket?.ticketId }] || []
        }
      }
    }).then((res) => {
      if (res) {
        associationSuccess();
        toast(
          'success',
          getTranslatedText(intl, 'ticket.unknown.association.success')
        );
        if (callback) callback();
      }
    });
  }

  function handleDelete() {
    softDeleteTicket({
      variables: {
        ids: [ticket?.ticketId] || []
      }
    }).then((res) => {
      if (res) {
        toast('success', getTranslatedText(intl, 'ticket.delete.toast'));
        deletionSuccess();
      }
    });
  }

  useEffect(() => {
    const fromEmailNotAvailable =
      metaData?.fromAddress === undefined || metaData?.fromAddress === null;
    if (selectedClient.client && fromEmailNotAvailable) GetTicketAudit();
  }, [selectedClient.client]);

  const deleteButton = () => {
    return (
      <DeleteModal
        modalActivator={
          <>
            {isClassicView ? (
              <div className="flex">
                <div className="flex mauto ptr">
                  <SVGIcon name="Delete" color="#C14136" />
                  <TextStyle variation="negative">
                    <FormattedMessage id="common.delete" />
                  </TextStyle>
                </div>
              </div>
            ) : (
              <Button
                icon={
                  <div id="delete-modal">
                    <SVGIcon name="Delete" color="#EC9E9E" />
                  </div>
                }
              />
            )}
          </>
        }
        title={getTranslatedText(intl, 'ticket.unknown.delete.title')}
        handleDeleteConfirmation={handleDelete}
        description={getTranslatedText(intl, 'ticket.details.delete.confirm')}
      />
    );
  };

  const associateButton = () => {
    return (
      <AssociateButton
        loading={loading}
        meta={metaData}
        selectedClient={selectedClient}
        setSelectedClient={setSelectedClient}
        onSubmit={onSubmit}
        submitLoading={convertTicketLoading}
        showButtonText={isClassicView}
      />
    );
  };

  return (
    <div>
      {!isClassicView ? (
        <ButtonGroup segmented>
          {deleteButton()}
          {associateButton()}
        </ButtonGroup>
      ) : (
        <>
          <div className="mb-10 mt-15">{associateButton()}</div>
          <div>{deleteButton()}</div>
        </>
      )}
    </div>
  );
};

export default withErrorBoundary(UnknownTicketActions);
